import Factory from "@Shared/Factory";
import { AllowanceTypes, ComponentTypes, Effected, QTYType } from "./enums";
const version2 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 2) {
        return current;
    }
    return { ...current, version: 2 };
};
const version3 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 3) {
        return current;
    }
    let { tariffComponents = [] } = current;
    tariffComponents = tariffComponents.map((object) => {
        if (object[Effected.TariffComponentType] !==
            ComponentTypes.Aggregated_Data) {
            return object;
        }
        let { [Effected.TariffComponentItems]: items = [] } = object;
        items = items.map((object_) => {
            if (object_[Effected.TariffComponentAllowanceQtyType] !==
                QTYType.Pooled ||
                object_[Effected.TariffComponentAllowanceType] !==
                    AllowanceTypes["UK Data (GB)"]) {
                return object_;
            }
            return {
                ...object_,
                [Effected.TariffComponentAllowanceQtyType]: QTYType.Aggregated,
            };
        });
        return { ...object, items };
    });
    return { ...current, tariffComponents, version: 3 };
};
const version4 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 4) {
        return current;
    }
    let { additionalData = {} } = current;
    additionalData = Object.keys(additionalData).reduce((object, key) => {
        const tariffComponentObject = additionalData[key];
        if (tariffComponentObject.additionalDataNoNewLine !== undefined) {
            tariffComponentObject.additionalDataNoNewLine =
                !tariffComponentObject.additionalDataNoNewLine;
        }
        object[key] = tariffComponentObject;
        return object;
    }, {});
    return { ...current, additionalData, version: 4 };
};
const version5 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 5) {
        return current;
    }
    let { tariffComponents = [] } = current;
    tariffComponents = tariffComponents.map((tariffComponent) => {
        const { discount, ...data } = tariffComponent;
        return { ...data, [Effected.TariffComponentDiscount]: discount };
    });
    return { ...current, tariffComponents, version: 5 };
};
export default (original = {}) => {
    const converted = [version2, version3, version4, version5].reduce((converted, f) => f(converted), original);
    let { version, DMOS, HWProRata, MDMDetails, MDMLineCost, MDMName, MDMOS, MDMRange, OS, PACCodeCharge, PACCost, UKUsageChargeable08, UKUsagePictureMsg, UKUsageUkIDDToAPAC, UKUsageUkIDDToEurope, UKUsageUkIDDToROW, UKUsageUkIDDToUSAandCanada, UKUsageUkToInternational, VIPService, VIPServiceResponseTime, WEEECertificates, accountManaged, accountManagerVisit, accountManagerVisitFrequency, additionalChargeDetails, additionalData, additionalIncrease, additionalIncreasePercentage, additionalInfo, additionalLines, additionalLinesCoTerminus, additionalLinesInfo, additionalNetworkInfo, alternativeSolution, analysisFrequency, appleDEP, billingRelationship, billingRelationshipChoice, breakClause, bundles = [], cashHW, changesOrRequirements, chargeForDelivery, chargeMethod, chargePerSim, chargeable08, complaintProcess, costForStatements, customTerms, deductSims, deductedPerSim, deliveryCharge, deliveryChargeMethod, deviceInsurance, devicePrices, directDebit, directDebitCost, discount, disposeHandsets, dmAlternative, dmEnterprise, dmFeatures, dmFree, dmLineCost, dmMinCommitmentPeriod, dmMinCommitmentPeriodOther, dmRange, dmTool, drawDown, eSims, enterpriseVersions, extraChargesInTenders, extraDeviceDetails, freeNextDay, fullRecycleValue, furtherMDM, handsetLocked, handsetProfitMargin, isManagementFee, managementFeeChargeMethod, managementFee, hasMinimumSpend, hwFundPerDataSim, hwFundPerLine, hwFundTaken, increaseMeasurement, increases, isCloudFree, keepSims, leasingData, leasingLumpSum, leasingNotes, leasingRequiresInsurance, mandatoryRise, mandatoryRisePercentage, minCommitmentPeriod, minCommitmentPeriodOther, minimumLeaseTerm, minimumSpend, monthlyLeasing, multipleNetworks, networkRelationship, networkSupport, networkVariant, nonDirectDebitCharges, nonDirectDebitCost, offerDM, offerLeasing, offerMDM, offeringPlanCom, ongoingAnalysis, ongoingAnalysisMethod, otherName, otherNetwork, paperStatements, penaltyPerLine, percentageIncrease, pictureMsg, planName, progress, proposalDependant, rackRate, reducedEffect, reducedHWFund, resolutionTime, responseTime, secondaryNetworks, selectNetworks, setupFee, simCost, tariffComponents, terminationPenalty, ticketSystem, timeLeftTerm, totalFund, totalMonthlyCost, ukIDDToAPAC, ukIDDToEurope, ukIDDToROW, ukIDDToUSAandCanada, ukToInternational, } = converted;
    bundles = bundles.map((b) => Factory.Bundle(b));
    return {
        version,
        progress,
        totalFund,
        hwFundTaken,
        cashHW,
        drawDown,
        deductSims,
        handsetProfitMargin,
        handsetLocked,
        appleDEP,
        networkVariant,
        deliveryCharge,
        OS,
        additionalLinesCoTerminus,
        reducedEffect,
        timeLeftTerm,
        hwFundPerLine,
        otherNetwork,
        hwFundPerDataSim,
        additionalLinesInfo,
        HWProRata,
        additionalInfo,
        accountManaged,
        complaintProcess,
        ticketSystem,
        responseTime,
        resolutionTime,
        freeNextDay,
        ongoingAnalysis,
        offeringPlanCom,
        ongoingAnalysisMethod,
        analysisFrequency,
        disposeHandsets,
        WEEECertificates,
        fullRecycleValue,
        PACCodeCharge,
        chargeMethod,
        customTerms,
        PACCost,
        terminationPenalty,
        penaltyPerLine,
        paperStatements,
        costForStatements,
        nonDirectDebitCharges,
        nonDirectDebitCost,
        extraChargesInTenders,
        totalMonthlyCost,
        isCloudFree,
        offerMDM,
        MDMLineCost,
        MDMName,
        MDMDetails,
        MDMOS,
        otherName,
        minCommitmentPeriod,
        MDMRange,
        enterpriseVersions,
        alternativeSolution,
        furtherMDM,
        multipleNetworks,
        selectNetworks,
        secondaryNetworks,
        billingRelationship,
        billingRelationshipChoice,
        networkRelationship,
        keepSims,
        VIPService,
        VIPServiceResponseTime,
        increases,
        additionalNetworkInfo,
        increaseMeasurement,
        additionalIncrease,
        percentageIncrease,
        breakClause,
        tariffComponents,
        proposalDependant,
        eSims,
        networkSupport,
        isManagementFee,
        managementFeeChargeMethod,
        managementFee,
        minimumSpend,
        hasMinimumSpend,
        reducedHWFund,
        changesOrRequirements,
        ukIDDToEurope,
        ukIDDToROW,
        ukIDDToUSAandCanada,
        ukIDDToAPAC,
        ukToInternational,
        pictureMsg,
        chargeable08,
        UKUsageUkIDDToEurope,
        UKUsageUkIDDToROW,
        UKUsageUkIDDToUSAandCanada,
        UKUsageUkIDDToAPAC,
        UKUsageUkToInternational,
        UKUsagePictureMsg,
        UKUsageChargeable08,
        bundles,
        rackRate,
        planName,
        devicePrices,
        offerLeasing,
        setupFee,
        monthlyLeasing,
        leasingData,
        leasingLumpSum,
        leasingNotes,
        deductedPerSim,
        simCost,
        accountManagerVisit,
        accountManagerVisitFrequency,
        additionalChargeDetails,
        discount,
        deviceInsurance,
        chargeForDelivery,
        extraDeviceDetails,
        deliveryChargeMethod,
        minimumLeaseTerm,
        leasingRequiresInsurance,
        directDebit,
        directDebitCost,
        mandatoryRise,
        additionalIncreasePercentage,
        mandatoryRisePercentage,
        minCommitmentPeriodOther,
        chargePerSim,
        offerDM,
        dmTool,
        DMOS,
        dmFeatures,
        dmFree,
        dmLineCost,
        dmMinCommitmentPeriod,
        dmMinCommitmentPeriodOther,
        dmRange,
        dmEnterprise,
        dmAlternative,
        additionalData,
        additionalLines,
    };
};
